import { useEffect, useState, useCallback } from "react"
import useErroPadrao from '../../../hooks/useErroPadrao';
import useHelp from '../../../hooks/useHelp';
import { useNavigate } from "react-router-dom";
import { CHAVE_TOKEN, real, dataBR, hojeISO } from "../../../utils/formata";

const categorias = {
    recebimento_parcela: "Recebimento de parcela",
    desembolso_emprestimo: "Desembolso de empréstimo",
    aporte: "Aporte de capital",
    despesa: "Despesa geral",
    aluguel: "Aluguel",
    salarios: "Salários / Comissões",
    combustivel: "Combustível / Transporte",
    alimentacao: "Alimentação",
    material: "Material / Equipamento",
    marketing: "Marketing / Anúncios",
    impostos: "Impostos / Taxas",
    outro: "Outro",
};

const categoriasSaida = ["despesa", "aluguel", "salarios", "combustivel", "alimentacao", "material", "marketing", "impostos", "outro"];

export default function CaixaConsulta() {
    const inicioMes = hojeISO().slice(0, 8) + "01";
    const [periodo, setPeriodo] = useState({ de: inicioMes, ate: hojeISO() });
    const [dados, setDados] = useState({ movimentacoes: [], totalEntradas: 0, totalSaidas: 0, saldo: 0 });
    const [carregando, setCarregando] = useState(true);
    const [novo, setNovo] = useState({ tipo: "entrada", categoria: "aporte", data: hojeISO() });
    const [lancando, setLancando] = useState(false);
    const { consultarMovimentacoes, adicionarMovimentacao, removerMovimentacao } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();

    const carregar = useCallback(() => {
        setCarregando(true);
        consultarMovimentacoes(periodo)
            .then((data) => setDados(data))
            .catch((error) => setErroPadrao(error))
            .finally(() => setCarregando(false));
    }, [periodo, consultarMovimentacoes, setErroPadrao]);

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) {
            navigate("/login");
            return;
        }
        carregar();
    }, [carregar, navigate]);

    function handleLancar(e) {
        e.preventDefault();
        setLancando(true);
        adicionarMovimentacao(novo)
            .then(() => { setNovo({ tipo: "entrada", categoria: "aporte", data: hojeISO() }); carregar(); })
            .catch((error) => setErroPadrao(error))
            .finally(() => setLancando(false));
    }

    function handleExcluir(id) {
        if (!window.confirm("Excluir esse lançamento do caixa?")) return;
        removerMovimentacao(id).then(carregar).catch((error) => setErroPadrao(error));
    }

    return (
        <div className="pagina">
            <h2 className="he-titulo">Caixa <span className="he-dourado">— Entradas & Saídas</span></h2>

            {/* Filtro de período */}
            <div className="form-mobile" style={{margin: "1em 0"}}>
                <div className="row" style={{alignItems: "flex-end"}}>
                    <div className="col-md-3 campo-form">
                        <label className="form-label he-dourado" style={{fontSize: "0.8em"}}>De</label>
                        <input className="form-control" type="date" value={periodo.de} onChange={(e) => setPeriodo({...periodo, de: e.target.value})}/>
                    </div>
                    <div className="col-md-3 campo-form">
                        <label className="form-label he-dourado" style={{fontSize: "0.8em"}}>Até</label>
                        <input className="form-control" type="date" value={periodo.ate} onChange={(e) => setPeriodo({...periodo, ate: e.target.value})}/>
                    </div>
                </div>
            </div>

            {/* Totais do período */}
            <div className="cards-estatistica" style={{marginBottom: "1em"}}>
                <div className="card-estat" style={{"--cor-acento": "#2ecc71"}}>
                    <div className="estat-rotulo">▲ ENTRADAS</div>
                    <div className="estat-numero" style={{color: "#2ecc71"}}>{real(dados.totalEntradas)}</div>
                </div>
                <div className="card-estat" style={{"--cor-acento": "#ff6b5b"}}>
                    <div className="estat-rotulo">▼ SAÍDAS</div>
                    <div className="estat-numero" style={{color: "#ff6b5b"}}>{real(dados.totalSaidas)}</div>
                </div>
                <div className="card-estat card-heroi">
                    <div className="estat-rotulo">= SALDO DO PERÍODO</div>
                    <div className="estat-numero">{real(dados.saldo)}</div>
                </div>
            </div>

            {/* Lançamento manual */}
            <form onSubmit={handleLancar} className="he-card form-mobile" style={{marginBottom: "1em"}}>
                <h6 className="he-titulo he-dourado"><i className="bi bi-plus-circle"></i> Lançamento manual</h6>
                <div className="row">
                    <div className="col-md-2" style={{marginBottom: 8}}>
                        <select className="form-select form-select-sm" value={novo.tipo} onChange={(e) => setNovo({...novo, tipo: e.target.value, categoria: e.target.value === "entrada" ? "aporte" : "despesa"})}>
                            <option value="entrada">Entrada</option>
                            <option value="saida">Saída</option>
                        </select>
                    </div>
                    <div className="col-md-2" style={{marginBottom: 8}}>
                        <select className="form-select form-select-sm" value={novo.categoria} onChange={(e) => setNovo({...novo, categoria: e.target.value})}>
                            {novo.tipo === "entrada" ?
                                <><option value="aporte">Aporte de capital</option><option value="outro">Outro</option></>
                                :
                                categoriasSaida.map((c) => <option key={c} value={c}>{categorias[c]}</option>)
                            }
                        </select>
                    </div>
                    <div className="col-md-2" style={{marginBottom: 8}}>
                        <input className="form-control form-control-sm" type="number" step="0.01" min="0.01" placeholder="Valor" value={novo.valor || ""} onChange={(e) => setNovo({...novo, valor: e.target.value})} required/>
                    </div>
                    <div className="col-md-2" style={{marginBottom: 8}}>
                        <input className="form-control form-control-sm" type="date" value={novo.data} onChange={(e) => setNovo({...novo, data: e.target.value})} required/>
                    </div>
                    <div className="col-md-3" style={{marginBottom: 8}}>
                        <input className="form-control form-control-sm" placeholder="Descrição" value={novo.descricao || ""} onChange={(e) => setNovo({...novo, descricao: e.target.value})}/>
                    </div>
                    <div className="col-md-1" style={{marginBottom: 8}}>
                        <button type="submit" className="btn btn-sm btn-he" style={{width: "100%"}} disabled={lancando}>
                            {lancando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-check-lg"></i> <span className="so-mobile-inline">Lançar</span></>}
                        </button>
                    </div>
                </div>
            </form>

            {carregando ? <div style={{textAlign: "center", padding: "2em"}}><span className="spinner-border" style={{color: "#d4af37"}}></span></div> :
            <div className="he-card sem-rolagem">
                <div className="tabela-rolavel rolagem-so-desktop">
                <table className="table table-striped table-hover tabela-responsiva" style={{fontSize: "0.9em"}}>
                    <thead>
                        <tr><th></th><th>Data</th><th>Categoria</th><th>Descrição</th><th>Empresa</th><th>Valor</th><th></th></tr>
                    </thead>
                    <tbody>
                        {dados.movimentacoes.map((m) => (
                            <tr key={m.id}>
                                <td className="esconder-mobile"><i className={m.tipo === "entrada" ? "bi bi-arrow-down-circle-fill" : "bi bi-arrow-up-circle-fill"} style={{color: m.tipo === "entrada" ? "#2ecc71" : "#ff6b5b"}}></i></td>
                                <td data-rotulo="Data">{dataBR(m.data)}</td>
                                <td className="principal ordem-primeiro" data-rotulo="Categoria">{categorias[m.categoria] || m.categoria}</td>
                                <td data-rotulo="Descrição">{m.descricao || "—"}</td>
                                <td data-rotulo="Empresa">{m.Empresa ? (m.Empresa.nomeFantasia || m.Empresa.razaoSocial) : "—"}</td>
                                <td className="destaque" data-rotulo="Valor" style={{fontWeight: 700, color: m.tipo === "entrada" ? "#2ecc71" : "#ff6b5b"}}>{m.tipo === "entrada" ? "+" : "-"}{real(m.valor)}</td>
                                <td className="acoes">
                                    {m.categoria !== "recebimento_parcela" && m.categoria !== "desembolso_emprestimo" &&
                                        <div className="acoes-linha uma-coluna">
                                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleExcluir(m.id)}><i className="bi bi-trash"></i> <span className="so-mobile-inline">Excluir lançamento</span></button>
                                        </div>
                                    }
                                </td>
                            </tr>
                        ))}
                        {dados.movimentacoes.length === 0 && <tr><td colSpan={7} style={{textAlign: "center", color: "#9aa5b5"}}>Nenhuma movimentação no período.</td></tr>}
                    </tbody>
                </table>
                </div>
            </div>}
        </div>
    )
}
